(function($){
    function checkScrollAction(){
        var winscroll = window.scrollY;
        if(winscroll >= 150){
            $("header#my-header").addClass("scrolling");
        } else {
            $("header#my-header").removeClass("scrolling");
        }
    }
    $(document).on('ready',function(){ 
        checkScrollAction();
    });
    $(window).on('scroll',function(){
        checkScrollAction();
    });
})(jQuery);

